var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"flex flex-wrap"},_vm._l((_vm.linksWithIcons),function(link){return _c('li',{key:link.key,staticClass:"inline-block text-base w-8"},[_c('a',{staticClass:"p-2 text-dark hover:opacity-50",attrs:{"href":link.value,"target":"_blank","title":link.label || link.key}},[_c('i',{class:link.icon})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }